import { Button, Checkbox, Form, Input, Modal, Select, Typography, message, Upload } from "antd";
import { DateSelect } from "../../../../components/dateSelect";
import InputMask from "../../../../components/inputMask";
import React, { useEffect, useState } from "react";
import { validateCPF, validatePhone } from "../../../../helpers/validators";
import { getEstados } from "../../../../api/estados";
import { getMunicipios } from "../../../../api/municipios";
import { getSexos } from "../../../../api/sexos";
import { PictureOutlined } from "@ant-design/icons";
const { Dragger } = Upload;
const { Text } = Typography;

const options_pcd = [
  { value: 1, label: "Sim" },
  { value: 0, label: "Não" },
];

const validator = {
  cpf: [
    { required: true, message: "Informe o CPF!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validateCPF(getFieldValue("cpf"))) {
          return Promise.resolve();
        }
        return Promise.reject("Informe um CPF válido!");
      },
    }),
  ],
  nome: [{ required: true, message: "Informe o nome completo!" }],
  data_nascimento: [{ required: true, message: "Informe a data de nascimento!" }],
  id_cad_municipios: [{ required: true, message: "Selecione o município!" }],
  id_cad_sexos: [{ required: true, message: "Selecione uma opção!" }],
  pcd: [{ required: true, message: "Selecione uma opção!" }],
  id_cad_estados: [{ required: true, message: "Selecione o estado!" }],
  termo_responsabilidade: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Aceite o termo!"))),
    },
  ],
  politica_privacidade: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Aceite a política!"))),
    },
  ],
  celular: [
    { required: true, message: "Informe o celular!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validatePhone(getFieldValue("celular"))) {
          return Promise.resolve();
        }
        return Promise.reject("Informe um celular válido!");
      },
    }),
  ],
  email: [
    {
      type: "email",
      message: "Informe um e-mail válido!",
    },
  ],
};

const CadastroUsuario = ({ onFinish, loadingComponent }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [sexos, setSexos] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    listarEstados();
    listarSexos();
  }, []);

  const listarSexos = async () => {
    setLoading(true);
    try {
      const retorno = await getSexos();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_sexos = [];
        for (let index = 0; index < data?.length; index++) {
          array_sexos.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }
        setSexos(array_sexos);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarEstados = async () => {
    setLoading(true);
    try {
      const retorno = await getEstados();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_estados = [];
        for (let index = 0; index < data?.length; index++) {
          array_estados.push({ value: data?.[index]?.uf, label: data?.[index]?.descricao });
        }
        setEstados(array_estados);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarMunicipios = async (uf) => {
    setLoading(true);
    try {
      const retorno = await getMunicipios(uf);
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_municipios = [];
        for (let index = 0; index < data?.length; index++) {
          array_municipios.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }

        setMunicipios(array_municipios);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const handleChangeEstado = (value) => {
    form?.setFieldsValue({ id_cad_municipios: undefined });
    listarMunicipios(value);
  };

  const onSubmit = (values) => {
    onFinish(values);
  };

  const formFile = (e) => {
    const formato = e?.file?.type === "image/jpeg" || e?.file?.type === "image/png";
    if (!formato) {
      message.error("Selecione uma imagem PNG/JPG!");
      return null;
    }
    const size = e?.file?.size / 1024 / 1024 > 20;
    if (size) {
      message.error("Tamanho não suportado, máximo 20MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <React.Fragment>
      <Modal
        title="Política de Privacidade"
        cancelText="Fechar"
        width={1000}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setShowModal(false)}
        open={showModal}>
        <iframe
          width={"100%"}
          height={600}
          src="https://statics.coperdia.com.br/curriculos/docs/politica_privacidade.html"
        />
      </Modal>

      <Form form={form} layout="vertical" autoComplete="off" onFinish={onSubmit}>
        <Form.Item name="cpf" label="CPF" hasFeedback rules={validator?.cpf}>
          <InputMask
            mask="999.999.999-99"
            size="large"
            placeholder="Informe o CPF"
            disabled={loading || loadingComponent}
          />
        </Form.Item>

        <Form.Item name="nome" label="Nome" hasFeedback rules={validator?.nome}>
          <Input size="large" placeholder="Informe o nome completo" disabled={loading || loadingComponent} />
        </Form.Item>

        <Form.Item name="data_nascimento" label="Data Nascimento" hasFeedback rules={validator?.data_nascimento}>
          <DateSelect size="large" disabled={loading || loadingComponent} />
        </Form.Item>

        <Form.Item name="id_cad_estados" label="Estado" hasFeedback rules={validator?.id_cad_estados}>
          <Select
            size="large"
            placeholder="Selecione o estado"
            options={estados}
            disabled={loading || loadingComponent}
            showSearch
            filterOption={(input, option) => (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase())}
            onChange={handleChangeEstado}
          />
        </Form.Item>

        <Form.Item name="id_cad_municipios" label="Município" hasFeedback rules={validator?.id_cad_municipios}>
          <Select
            size="large"
            placeholder="Selecione o município"
            options={municipios}
            disabled={loading || loadingComponent}
            showSearch
            filterOption={(input, option) => (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())}
          />
        </Form.Item>

        <Form.Item name="pcd" label="PCD (Pessoa Com Deficiência)" hasFeedback rules={validator?.pcd}>
          <Select size="large" placeholder="Selecione uma opção" options={options_pcd} disabled={loading} />
        </Form.Item>

        <Form.Item name="id_cad_sexos" label="Sexo" hasFeedback rules={validator?.id_cad_sexos}>
          <Select size="large" placeholder="Selecione uma opção" options={sexos} disabled={loading} />
        </Form.Item>

        <Form.Item name="celular" label="Celular" hasFeedback rules={validator?.celular}>
          <InputMask
            mask="(99) 9 9999-9999"
            size="large"
            placeholder="Informe o celular"
            disabled={loading || loadingComponent}
          />
        </Form.Item>

        <Form.Item name="email" label="E-mail (Opcional)" hasFeedback rules={validator?.email}>
          <Input size="large" placeholder="Informe o e-mail" disabled={loading || loadingComponent} />
        </Form.Item>

        <Form.Item
          getValueFromEvent={formFile}
          name="imagem"
          label="Foto Perfil (Opcional)"
          valuePropName="fileList"
          hasFeedback
          multiple={false}
          rules={validator?.imagem}>
          <Dragger
            disabled={loading || loadingComponent}
            beforeUpload={() => false}
            accept=".png, .jpg, .jpeg"
            listType="picture"
            maxCount={1}>
            <p className="ant-upload-drag-icon">
              <PictureOutlined />
            </p>
            <p className="ant-upload-text">Adicione aqui uma foto sua (PNG/JPG)</p>
            <p className="ant-upload-hint">Clique ou arraste para enviar o arquivo</p>
          </Dragger>
        </Form.Item>

        <Form.Item name="termo_responsabilidade" valuePropName="checked" rules={validator?.termo_responsabilidade}>
          <Checkbox disabled={loading || loadingComponent}>
            Declaro que as informações acima prestadas são verdadeiras, e assumo a inteira responsabilidade pelas
            mesmas.
          </Checkbox>
        </Form.Item>

        <Form.Item name="politica_privacidade" valuePropName="checked" rules={validator?.politica_privacidade}>
          <Checkbox disabled={loading || loadingComponent}>
            <Text>Concordo com a política de privacidade. </Text>
            <Button type="link" style={{ padding: 0 }} onClick={() => setShowModal(true)}>
              Ver termo
            </Button>
          </Checkbox>
        </Form.Item>

        <Button size="large" type="primary" loading={loading || loadingComponent} htmlType="submit">
          Próximo
        </Button>
      </Form>
    </React.Fragment>
  );
};

export { CadastroUsuario };
